import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobTeaserCustomInfoSlotProps {
  /**
   * The job to display the custom info for.
   */
  job: Slottable<Job>;
}

export function JobTeaserCustomInfoSlot({ job }: JobTeaserCustomInfoSlotProps) {
  return null;
}

export default JobTeaserCustomInfoSlot;
